import { Routes } from "@angular/router";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthGuard } from "./guards/auth.guard";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";
import { LoginComponent } from "./pages/login/login.component";
import { CompanyComponent } from "./pages/company/company.component";
import { CompanyFormComponent } from "./pages/company/company-form/company-form.component";
import { LoginGuard } from "./guards/login.guard";
import { RegisterComponent } from "./pages-originals/register/register.component";
import { CategoryComponent } from "./pages/category/category.component";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      { path: "login", canActivate: [LoginGuard], component: LoginComponent },
      {
        path: "register",
        canActivate: [LoginGuard],
        component: RegisterComponent,
      },
    ],
  },
  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "dashboard",
        loadComponent: () =>
          import("./pages/dashboard/dashboard.component").then(
            (m) => m.DashboardComponent
          ),
      },
      { path: "categorias", component: CategoryComponent },
      { path: "empresas", component: CompanyComponent },
      {
        path: "empresa",
        children: [
          {
            path: "cadastro/:id",
            component: CompanyFormComponent,
          },
        ],
      },
    ],
  },
  { path: "**", redirectTo: "/dashboard" },
];
